import { RacePageDataTransferObject, StarterDataTransferObject } from '@mobi/api-types'
import { convertRaceDateTimeStringToDate } from '@mobi/utils/date'
import MissingStartersException from '../Exceptions/MissingStartersException'
import { IObservableStarter } from '../Model/Observables/IObservableStarter'
import ObservableRaceKey from '../Model/Observables/ObservableRaceKey'
import ObservableRaceKeyPoolInfo from '../Model/Observables/ObservableRaceKeyPoolInfo'
import ObservableRacePage from '../Model/Observables/ObservableRacePage'
import PoolMapper from './PoolMapper'
import StarterBuilder from './StarterBuilder'

export default {
  map(dto: RacePageDataTransferObject, model: ObservableRacePage) {
    if (!dto || !dto.RaceStarters) throw new MissingStartersException('No starters available')

    for (const leg of dto.RaceStarters) {
      const poolInfo = new ObservableRaceKeyPoolInfo(leg.RaceKey.RaceNumber)
      poolInfo.hasPlacePool(leg.RaceKey.PoolInfo.HasPlacePool)
      poolInfo.hasWinPool(leg.RaceKey.PoolInfo.HasWinPool)
      poolInfo.hasWinPlacePool(leg.RaceKey.PoolInfo.HasWinPlacePool)
      poolInfo.hasQuinellaPool(leg.RaceKey.PoolInfo.HasQuinellaPool)

      const key = new ObservableRaceKey()
      key.raceNumber(leg.RaceKey.RaceNumber)
      key.leg(leg.RaceKey.Leg)
      key.startTime(convertRaceDateTimeStringToDate(leg.RaceKey.StartTime))
      key.tips(leg.RaceKey.Tips)
      key.tipster(leg.RaceKey.Tipster)
      key.name(leg.RaceKey.Name)
      key.pay(leg.RaceKey.Pay)
      key.distance(leg.RaceKey.Distance)
      key.poolInfo.merge(poolInfo)

      PoolMapper.mapAllUpPools(leg.RaceKey, key)

      key.isDoubleLeg(leg.RaceKey.IsDoubleLeg)
      key.isQuaddieLeg(leg.RaceKey.IsQuaddieLeg)

      const starters = []
      for (const starter of leg.Starters) {
        starters.push(StarterBuilder.from(starter.Type).build(starter))
      }
      model.addStartersForRace(key, starters)
    }
  },

  mapStarters(starters: StarterDataTransferObject[]): IObservableStarter[] {
    const observableStarters = []
    for (const starter of starters) {
      observableStarters.push(StarterBuilder.from(starter.Type).build(starter))
    }
    return observableStarters
  },
}
